import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]
  
  connect() {
    console.log("🔧 Hello controller connected!")
    if (this.hasOutputTarget) {
      this.outputTarget.textContent = "Connected! Stimulus is working."
    }
  }
}
